
export default {
  vessel: {
    box: {
      borderRadius: 'lg',
      padding: { all: 'lg', lg: 'xl', xl: '2xl' },
      color: 'white'
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.banner = await $content(locale, 'data/product-banner').fetch()
  },
  data() {
    return {
      banner: null
    }
  }
}
